import { createThunkRoutine } from 'redux-thunk-routine';
import { CREATE_FEATURE_FLAG, GET_FEATURE_FLAGS, GET_USER_FEATURE_FLAGS, GET_ASSIGNED_USERS } from './action-types';

export const CreateFeatureFlagRoutine = createThunkRoutine(CREATE_FEATURE_FLAG);
export const GetFeatureFlagsRoutine = createThunkRoutine(GET_FEATURE_FLAGS);
export const GetFeatureUserFlagsRoutine = createThunkRoutine(GET_USER_FEATURE_FLAGS);
export const GetAssignedUsersRoutine = createThunkRoutine(GET_ASSIGNED_USERS);